module.exports = __webpack_public_path__ + "static/img/logo_01.b48c29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_01.png
// module id = QFhU
// module chunks = 12